import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './baseQuery';
import { eventApi } from './eventApi';

// Define a service using a base URL and expected endpoints
export const pointRuleApi = createApi({
  reducerPath: 'PointRuleApi',
  tagTypes: ['PointRule', 'upload'],
  baseQuery: axiosBaseQuery(),
  endpoints: builder => ({
    getAllPointRule: builder.query({
      query: params => ({
        url: `/point_rules${params && '?' + params}`,
        method: 'GET',
      }),
      providesTags: ['PointRule'],
      transformResponse: (response: { point_rules_response: [] }, meta, arg) =>
        response?.point_rules_response,
    }),
    createPointRule: builder.mutation<any, any>({
      query(body) {
        return {
          url: '/point_rules',
          method: 'POST',
          data: body,
        };
      },
      invalidatesTags: ['PointRule'],
      async onQueryStarted({ id, ...patch }, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(
            eventApi.endpoints.getFormModalBannerPoint.initiate(undefined, {
              forceRefetch: true,
            }),
          );
        } catch (err) {
          console.log(err);
        }
      },
    }),
    deletePointRule: builder.mutation<any, string>({
      query(id) {
        return {
          url: `/point_rules/${id}`,
          method: 'Delete',
        };
      },
      invalidatesTags: ['PointRule'],
    }),
    updatePointRule: builder.mutation<any, any>({
      query({ id, body }) {
        return {
          url: `/point_rules/${id}`,
          method: 'PUT',
          data: body,
        };
      },
      invalidatesTags: ['PointRule'],
    }),
    uploadFile: builder.mutation<any, FormData>({
      query(file) {
        return {
          url: '/point_rules/upload',
          method: 'POST',
          body: file,
        };
      },
      invalidatesTags: [{ type: 'upload', id: 'UP' }],
      transformResponse: result => result,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllPointRuleQuery,
  useCreatePointRuleMutation,
  useDeletePointRuleMutation,
  useUpdatePointRuleMutation,
  useUploadFileMutation,
} = pointRuleApi;
